import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/modules/auth'
import products from '@/store/modules/products'
import states from '@/store/modules/states'
import orders from '@/store/modules/orders'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windowTitle: '',
    applicationTitle: "RE Titles & Deeds",
  },
  mutations: {
    setWindowTitle( state, newTitle) {
      state.windowTitle = newTitle;
    }
  },
  actions: {
    updateWindowTitle({ commit }, {newTitle}) {
      commit('setWindowTitle', newTitle)
    }
  },

  modules: {
    auth,
    products,
    states,
    orders
  },
})

